/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, waited: NonNullable<unknown> }} Order_Lot_Debt_Badge_WaitedInputs */

const vi_order_lot_debt_badge_waited = /** @type {(inputs: Order_Lot_Debt_Badge_WaitedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nợ ${i?.count} loại · ${i?.waited}`)
};

/**

* @param {Order_Lot_Debt_Badge_WaitedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_lot_debt_badge_waited = /** @type {((inputs: Order_Lot_Debt_Badge_WaitedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Lot_Debt_Badge_WaitedInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_lot_debt_badge_waited(inputs)
});